import React, { Component } from 'react'
import CacheKeys from '../../../cache/CacheKeys.js'
import CacheManager from '../../../cache/CacheManager.js'
import AllChatPageUI from './AllChatPageUI.js'

class AllChatPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      accountUserList: null,
      searchFilter: '',
      checked: false
    }
  }

  render() {
    return (
      <AllChatPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        onRefreshClick={this.onRefreshClick}
        //
        filteredList={this.state.filteredList}
        searchFilter={this.state.searchFilter}
        onSearchFilterChange={this.onSearchFilterChange}
        //
        checked={this.state.checked}
        onShowUnread={this.onShowUnread}
      />
    )
  }

  onShowUnread = () => {
    let context = this.props.context
    let newChecked = !this.state.checked
    this.setState({
      checked: newChecked
    })
    this.getChats(context)
  }

  componentDidMount() {
    let context = this.props.context
    this.getChats(context)
  }

  getChats(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/chatMessages/statuses/recent/unread/draft`,
      cacheKey: CacheKeys.Chats(),
      callback: this.getChatsCallback,
      ttlInSecs: 0
    })
    cacheManager.getObject2(context)
  }

  getChatsCallback = (response) => {
    let accountUserList = response.accountMessageList.map((account) => {
      return {
        accountId: account.accountId, accountName: account.accountName,
        latestMessage: account.latestMessage, noOfUnreadMessages: account.noOfUnreadMessages,
        latestDraftMessage: account.latestDraftMessage
      }
    })
    let unreadList = accountUserList.filter(account => account.noOfUnreadMessages > 0)

    let filtersStr = sessionStorage.getItem(CacheKeys.AccountsFilter())
    let filters = filtersStr ? JSON.parse(filtersStr) : {}

    this.applyFilters(this.state.checked ? unreadList : accountUserList, filters.searchFilter ? filters.searchFilter : '', response.errorList)
  };

  onSearchFilterChange = (event) => {
    let searchFilter = event.target.value
    this.setState({ searchFilter: searchFilter })
    this.applyFilters(this.state.accountUserList, searchFilter)
  }

  applyFilters(accountUserList, searchFilter, errorList) {
    let filteredList = accountUserList
    if (searchFilter) {
      searchFilter = searchFilter.toLocaleLowerCase()
      filteredList = filteredList.filter(acc =>
        acc.accountName.toLocaleLowerCase().includes(searchFilter) ||
        (acc.userName && acc.userName.toLocaleLowerCase().includes(searchFilter))
      )
    }

    this.setState({
      accountUserList: accountUserList,
      filteredList: filteredList,
      searchFilter: searchFilter,
      errorList: errorList
    })

    let filters = { searchFilter: searchFilter }
    sessionStorage.setItem(CacheKeys.AccountsFilter(), JSON.stringify(filters))
  }

  onRefreshClick = (noBusy) => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Chats())
    if (noBusy === 'noBusy') {
      this.getChats(context)
    } else {
      this.setState({ accountUserList: null, filteredAccountList: null, errorList: null }, () => this.getChats(context))
    }
  }
}

export default AllChatPageSF
